var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_4749_30370)" } }, [
        _c("path", {
          attrs: {
            d:
              "M14.265 6.53114L24.3558 6.53114L31.9964 14.1718L31.9963 24.6777L24.674 32L13.8498 32L6.52746 24.489L6.52754 14.1718L14.265 6.53114Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M15.2468 9.24903L23.617 9.29754L29.5013 15.2505L29.4528 23.6206L23.4999 29.505L15.1297 29.4565L9.24535 23.5035L9.29385 15.1333L15.2468 9.24903Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M18.3517 16.868L20.4252 16.88L21.8829 18.3547L21.8709 20.4282L20.3962 21.8859L18.3227 21.8738L16.865 20.3992L16.877 18.3257L18.3517 16.868Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M16.3654 11.9939L22.4669 12.0292L26.7563 16.3686L26.7209 22.4701L22.3815 26.7595L16.28 26.7241L11.9906 22.3847L12.026 16.2832L16.3654 11.9939ZM14.5667 17.3529L14.5436 21.3445L17.3497 24.1834L21.3413 24.2065L24.1802 21.4004L24.2033 17.4088L21.3972 14.5699L17.4056 14.5468L14.5667 17.3529Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M6.30742 0L10.316 4.04988L10.316 10.2874L3.94878 10.2875L0 6.29858V3.92025H3.94877L3.94876 0H6.30742Z",
            fill: "#535353"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M0.929075 0.0320258L16.3696 15.4726L18.05 13.7923L19.5872 19.5294L13.8501 17.9921L15.4692 16.373L0.0286162 0.932485L0.929075 0.0320258Z",
            fill: "black"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_4749_30370" } }, [
          _c("rect", { attrs: { width: "32", height: "32", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }